<template>
  <div>
    <modal name="validar-documento" :width="1000" :height="600" :clickToClose="false" :scrollable="true">
      <div class="modal-content modalContent">
        <span class="closebtn" @click="closeModal">&times;</span>
          <div class="text-center mt-4">
              <h3 class="with-lines">Validación de archivos solicitados </h3>
          </div>
          <div class="row p-4 scrollable-content">
              <div class="table-responsive">
                <table class="table text-center">
                  <thead>
                      <tr>
                      <th scope="col">Requisito</th>
                      <th scope="col">Visor</th>
                      <th scope="col">Status</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr  v-for="(result, i) in listArchivos" :key="i">
                          <td style="width: 290px;"><p class="mt-2" style="line-height:0px">{{result.tipoArchivo}}</p>{{result.NombreArchivo}}</td>
                          <td style="width: 290px;">
                              <button type="button" @click="mostrarPDF(result.archivoB64, result.NombreArchivo)" class="btn btn-blue">
                                  <i  style="color:#fffdfd;" class=" mr-2 far fa-eye"></i>
                                  Ver
                              </button>
                          </td>
                          <td style="width: 220px;">
                            <div class="form-check"   v-if="result.IdArchivo != '140'">
                                <input class="form-check-input" @change="changeStatus($event, result.selectedFile)" :value="true" v-model="result.selectedFile" type="radio" :name="'flexRadioCorrecto' + i" :id="'correcto' + i">
                                <label class="form-check-label" >
                                    Correcto
                                </label>
                            </div>
                            <div class="form-check"   v-if="result.IdArchivo != '140'">
                                <input class="form-check-input" @change="changeStatus($event, result.selectedFile)" :value="false" v-model="result.selectedFile" type="radio" :name="'flexRadioCorrecto' + i" :id="'soli' + i">
                                <label class="form-check-label" >
                                    Solicitar nuevamente
                                </label>
                            </div>
                        </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col">
                <button class=" btn btn-blue col-5" @click="sendValidacion">
                  <i class="fas fa-paper-plane mr-1"></i>
                  Enviar
                </button>
              </div>
            </div>
          </div>
      </div>
      
    </modal>
  </div>
</template>

<script>
export default {
name: 'App',
props: {
    listArchivos: Array,
    changeStatus: Function,
    mostrarPDF: Function,
    sendValidacion: Function,
},
data() {
  return {
  };
},
methods: {
  closeModal() {
    this.$modal.hide('validar-documento');
  },
}
};
</script>

<style >
/* Limitar la altura del contenido y hacer que sea scrolleable */
.scrollable-content {
max-height: 500px; /* Ajusta este valor según sea necesario */
overflow-y: auto;
}

.file-select {
position: relative;
display: inline-block;
cursor: pointer !important;
}

.file-select::before {
background-color: #ffffff;
color: rgba(4, 12, 34, 0.664);
display: flex !important;
justify-content: center !important;
align-items: center !important;
content: 'Seleccionar';
position: absolute !important;
left:5% !important;
top: 20% !important;
cursor: pointer !important;
}

.file-select input[type="file"] {
opacity: 0 !important;
width: 200px !important;
height: 32px !important;
display: inline-block !important;
cursor: pointer !important;
}

.btn-blue {
border-radius: 10px;
background-image: linear-gradient(to right, #085da8, #003c71);
border: #ffffff;
color: white;
}

.vm--modal {
position: relative;
overflow: hidden;
box-sizing: border-box;
background-color: white;
border-radius: 30px !important;
}

.modalContent {
padding: 15px;
background-color: white;
color: white;
border-radius: 15px;
position: relative;
text-align: center;
border-color: white;
}

.closebtn {
position: absolute;
top: 10px;
right: 15px;
color: #003c71;
font-weight: bold;
font-size: 22px;
line-height: 20px;
cursor: pointer;
transition: 0.3s;
}

.closebtn:hover {
color: #003c718c;
}

.iframe-content {
width: 100%;
height: calc(100% - 50px);
border-color: white;
border-radius: 0 0 15px 15px;
}

.modal-header {
font-size: 1.25rem;
font-weight: bold;
margin-bottom: 15px;
color: #003c71;
}

.modal-body {
padding: 20px;
}
</style>
